.logo {
  font-size: 1.7rem;
  font-weight: bold;
}

.image {
  padding-bottom: 13px;
  height: 1em;
  vertical-align: middle;
}
